// The chat model sometimes writes a Report Pages path as `https://app/reports/...`, reading the leading
// `/app` segment as a host. A host of exactly `app` is that segment, so it is put back as the path.
const MODEL_WRITTEN_APP_HOST = /^https?:\/\/(app(?:[/?#].*)?)$/

/**
 * The in-app route a chat link points at, or `undefined` when the link is not an in-app one. An in-app link is a
 * root-relative path (one leading `/`) or the model-written `https://app/...` form of one.
 */
export const toInAppPath = (href: string | undefined): string | undefined => {
  if (!href) return undefined
  const hosted = MODEL_WRITTEN_APP_HOST.exec(href)
  const path = hosted ? `/${hosted[1]}` : href
  return /^\/(?!\/)/.test(path) ? path : undefined
}
